/**
 * Catalog context, logo file validation (pure; copy from
 * docs/ux/screens/BusinessProfileEditScreen.md, elements 2 / unhappy 4–5).
 * Mirrors the storage bucket's own limits (2 MB, png/jpeg/webp) so the user
 * gets the friendly message, not a storage error.
 */

export const LOGO_MAX_BYTES = 2 * 1024 * 1024;

const LOGO_TYPES: Record<string, string> = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/webp": "webp",
};

export type LogoCheck =
  | { ok: true; contentType: string; extension: string }
  | { ok: false; error: string };

export function checkLogoFile(file: { type: string; size: number }): LogoCheck {
  const extension = LOGO_TYPES[file.type];
  if (!extension) {
    return { ok: false, error: "Use a PNG, JPEG or WebP image." };
  }
  if (file.size > LOGO_MAX_BYTES) {
    return { ok: false, error: "Keep the logo under 2 MB." };
  }
  if (file.size === 0) {
    return { ok: false, error: "Use a PNG, JPEG or WebP image." };
  }
  return { ok: true, contentType: file.type, extension };
}
